export const TREATMENT_PLAN_FEATURE_FLAG = 'growth-public-site-treatment-plan-enabled';

/** Severity levels of Dx */
export const SEVERITY = ['mild', 'moderate', 'severe'];
export const NUMBERED_STAGE = ['stage 0', 'stage I', 'stage II', 'stage III', 'stage IV'];
export const RISK = [
  'normal',
  'borderline',
  'elevated',
  'low risk',
  'moderate risk',
  'high risk',
  'severe',
];
export const GRADE = ['low grade', 'medium grade', 'high grade'];
export const STAGE = ['early', 'intermediate', 'advanced'];

export const ALL_SEVERITIES = [SEVERITY, NUMBERED_STAGE, RISK, GRADE, STAGE];
